import {useEffect, useState} from 'react';

export function useFacebookPosts() {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/facebook-posts')
      .then(res => res.json())
      .then(data => {
        setPosts(data?.posts ?? []);
      })
      .catch(() => {
        setPosts([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {posts, loading};
}
